import React from 'react';
import moment from 'moment';
import { I18n } from '@aws-amplify/core';

import * as S from './styles';

interface TableActionPlanEvaluationRiskProps {
	categoryPrevious: any;
}

export const TableActionPlanEvaluationRisk = ({
	categoryPrevious
}: Readonly<TableActionPlanEvaluationRiskProps>): JSX.Element => {
	return (
		<S.TableWrapper>
			{categoryPrevious.action_plan && categoryPrevious.action_plan ? (
				<S.CustomTable>
					<thead>
						<tr>
							<th colSpan={4}>{categoryPrevious.action_plan.title}</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td colSpan={2}>
								<span>{I18n.get('Responsible')}: </span>
								{categoryPrevious.action_plan.responsible_user.name}
							</td>
							<td colSpan={2}>
								<span>{I18n.get('Due date')}: </span>
								{moment(categoryPrevious.action_plan.due_date).format('DD/MM/YYYY')}
							</td>
						</tr>
						<tr>
							<td colSpan={4}>
								<span>{I18n.get('Description')}: </span>
								{categoryPrevious.action_plan.description || '-'}
							</td>
						</tr>
					</tbody>
					<thead>
						<tr>
							<th colSpan={4}>{I18n.get('Tasks')}</th>
						</tr>
					</thead>
					<tbody>
						{categoryPrevious.action_plan.tasks.map((task: any) => (
							<tr>
								<td style={{ width: '25%', textAlign: 'center' }}>{task.title}</td>
								<td style={{ width: '25%', textAlign: 'center' }}>
									{task.responsible_user.name || '-'}
								</td>
								<td style={{ width: '25%', textAlign: 'center' }}>
									{task.due_date ? moment(task.due_date).format('DD/MM/YYYY') : '-'}
								</td>
								<td style={{ width: '25%', textAlign: 'center' }}>
									<S.StatusTaskBadge isFinished={task.is_completed}>
										{task.is_completed ? I18n.get('Finished') : I18n.get('Not finished')}
									</S.StatusTaskBadge>
								</td>
							</tr>
						))}
					</tbody>
				</S.CustomTable>
			) : (
				<S.CustomTable>
					<thead>
						<tr>
							<th style={{ textAlign: 'center' }}>{I18n.get('Action plan')}</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td style={{ textAlign: 'center' }}>{I18n.get('No data')}</td>
						</tr>
					</tbody>
				</S.CustomTable>
			)}
		</S.TableWrapper>
	);
};
